export const PublishTypes = {
  publish: 'publish',
  update: 'update',
  schedule: 'schedule',
  cancelScheduledUnpublish: 'cancelScheduledUnpublish',
  unpublish: 'unpublish'
};